import { FC, MouseEventHandler } from 'react';

import Button from 'app/components/v2/components/Button';
import Dialog from 'app/components/v2/components/Dialog';
import DialogActions from 'app/components/v2/components/Dialog/DialogActions';
import DialogContent from 'app/components/v2/components/Dialog/DialogContent';
import DialogTitle from 'app/components/v2/components/Dialog/DialogTitle';
import Paragraph from 'app/components/v2/components/Text/Paragraph';

// Local Typings
interface Action {
  isPrimaryAction?: boolean;
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
}
export interface AlertUIProps {
  actions: Action[];
  message?: string;
  title: string;
}

// Component Definition
const AlertUI: FC<AlertUIProps> = props => (
  <Dialog
    aria-describedby="alert-dialog-description"
    aria-labelledby="alert-dialog-title"
    isOpen
  >
    <DialogContent fullWidth>
      <DialogTitle>
        {props.title}
      </DialogTitle>

      {props.message && (
        <Paragraph>
          {props.message}
        </Paragraph>
      )}
    </DialogContent>
    <DialogActions noPaddingTop>
      {props.actions.map(action => (
        <Button
          hierarchy={action.isPrimaryAction ? 'primary' : 'tertiary'}
          key={action.label}
          onClick={action.onClick}
        >
          {action.label}
        </Button>
      ))}
    </DialogActions>
  </Dialog>
);

export default AlertUI;
